import { convexClient, hasLiveConvex } from './convexClient';
import { idbStorage } from './idbStorage';

  // --- PWA Upload Fixer: canvas-based compression + localStorage fallback ---
  const compressImage = (file, maxDim = 800, qualities = [0.8, 0.5, 0.3]) => {
    return new Promise((resolve, reject) => {
      const tempUrl = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        let { width, height } = img;
        if (width > maxDim || height > maxDim) {
          if (width > height) { height = Math.round(height * maxDim / width); width = maxDim; }
          else { width = Math.round(width * maxDim / height); height = maxDim; }
        }
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        URL.revokeObjectURL(tempUrl);
        for (const q of qualities) {
          try {
            const data = canvas.toDataURL('image/jpeg', q);
            resolve(data);
            return;
          } catch (_) {}
        }
        reject(new Error('All compression qualities failed'));
      };
      img.onerror = () => { URL.revokeObjectURL(tempUrl); reject(new Error('Image load failed')); };
      img.src = tempUrl;
    });
  };
  // --- End PWA Upload Fixer snippet ---


export const postService = {
  _mapLatestProfiles(posts) {
    const savedUser = JSON.parse(localStorage.getItem('convex_user') || 'null');
    const mockProfiles = JSON.parse(localStorage.getItem('mock_profiles') || '{}');
    
    return posts.map(post => {
      const authorId = post.userId || post.user_id;
      let updatedAuthor = { ...post.author };
      
      if (savedUser && authorId === savedUser.id) {
        updatedAuthor.full_name = savedUser.fullName || savedUser.full_name || updatedAuthor.full_name || 'You';
        updatedAuthor.username = savedUser.username || updatedAuthor.username || 'you';
        updatedAuthor.avatar_url = savedUser.avatarUrl || savedUser.avatar_url || updatedAuthor.avatar_url;
      } else if (mockProfiles[authorId]) {
        const p = mockProfiles[authorId];
        updatedAuthor.full_name = p.full_name || updatedAuthor.full_name;
        updatedAuthor.username = p.username || updatedAuthor.username;
        updatedAuthor.avatar_url = p.avatar_url || updatedAuthor.avatar_url;
      }
      
      return {
        ...post,
        author: updatedAuthor
      };
    });
  },

  async getPosts() {
    try {
      // v6: Self-hosted videos — served from Vercel CDN, always playable
      if (!localStorage.getItem('seed_v6_done')) {
        localStorage.removeItem('local_posts');
        localStorage.removeItem('seed_v5_posts_done');
        localStorage.setItem('seed_v6_done', 'true');
      }

      if (!localStorage.getItem('seed_v6_posts_done')) {
        const localPosts = [];

        // Post 1: 3D Astronaut model
        localPosts.push({
          id: 'v6_3d_astronaut',
          content: 'Just finished this sci-fi Astronaut asset — procedural texturing in Substance, baked to GLB. Drag to spin! 🚀 #3D #VFX #CGI',
          user_id: 'seed_vfx', userId: 'seed_vfx',
          model_url: 'https://modelviewer.dev/shared-assets/models/Astronaut.glb',
          media_type: 'model',
          created_at: new Date(Date.now() + 8000).toISOString(),
          likes: [], comments: [],
          author: { id: 'seed_vfx', full_name: 'Alex Vanguard', username: 'vanguard_vfx',
            avatar_url: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150&h=150&fit=crop' }
        });

        // Post 2: FPS / Call of Duty style
        localPosts.push({
          id: 'v6_cod_fps',
          content: 'Omnimovement changes everything! Dive, shoot, evade — the skill gap just got real. 🔫🔥 #CallOfDuty #COD #FPS #Gaming',
          user_id: 'seed_fps_pro', userId: 'seed_fps_pro',
          video_url: '/videos/fps_game.mp4',
          media_type: 'video',
          created_at: new Date(Date.now() + 7000).toISOString(),
          likes: [], comments: [],
          author: { id: 'seed_fps_pro', full_name: 'Ghost Protocol', username: 'ghost_protocol',
            avatar_url: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop' }
        });

        // Post 3: War game
        localPosts.push({
          id: 'v6_war_fps',
          content: 'The new engine is INSANE. Next-gen warfare with dynamic lighting — this is what Battlefield should have been. 💥🎖️ #WarGame #Battlefield #FPS',
          user_id: 'seed_fps_vet', userId: 'seed_fps_vet',
          video_url: '/videos/war_game.mp4',
          media_type: 'video',
          created_at: new Date(Date.now() + 6000).toISOString(),
          likes: [], comments: [],
          author: { id: 'seed_fps_vet', full_name: 'Veteran Sniper', username: 'vet_sniper',
            avatar_url: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?w=150&h=150&fit=crop' }
        });

        // Post 4: GTA6 / cinematic open world
        localPosts.push({
          id: 'v6_gta6_cinematic',
          content: 'Leonida is looking MASSIVE. Global illumination, neon-soaked nights, and next-gen crowds — who else is counting down? 🌴🐊 #GTA6 #OpenWorld #NextGen',
          user_id: 'seed_rockstar_fan', userId: 'seed_rockstar_fan',
          video_url: '/videos/cinematic.mp4',
          media_type: 'video',
          created_at: new Date(Date.now() + 5000).toISOString(),
          likes: [], comments: [],
          author: { id: 'seed_rockstar_fan', full_name: 'Tech & Gaming', username: 'tech_gamer',
            avatar_url: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=150&h=150&fit=crop' }
        });

        // Post 5: Need for Speed racing
        localPosts.push({
          id: 'v6_nfs_racing',
          content: 'Night city sprint — turbocharged engine, rain-slicked streets, pure adrenaline. This is what racing games should FEEL like. 🏎️⚡ #NeedForSpeed #NFS #Racing',
          user_id: 'seed_racer', userId: 'seed_racer',
          video_url: '/videos/racing_game.mp4',
          media_type: 'video',
          created_at: new Date(Date.now() + 4000).toISOString(),
          likes: [], comments: [],
          author: { id: 'seed_racer', full_name: 'Speed Demon', username: 'speed_demon',
            avatar_url: 'https://images.unsplash.com/photo-1541443131876-44b03de101c5?w=150&h=150&fit=crop' }
        });

        localStorage.setItem('local_posts', JSON.stringify(localPosts));
        localStorage.setItem('seed_v6_posts_done', 'true');
      }

      if (!localStorage.getItem('seed_v6_fps_extra_done')) {
        const localPosts = JSON.parse(localStorage.getItem('local_posts') || '[]');

        // Extra COD post 1
        localPosts.unshift({
          id: 'v6_cod_extra1',
          content: 'Black Ops 6 campaign is absolutely WILD. The story goes places no COD has gone before. That plot twist in mission 4... I\'m not spoiling it. 🤯🔫 #BlackOps6 #COD #CallOfDuty #FPS',
          user_id: 'seed_cod1', userId: 'seed_cod1',
          video_url: '/videos/cod_real_1.mp4',
          media_type: 'video',
          created_at: new Date(Date.now() + 12000).toISOString(),
          likes: [], comments: [],
          author: { id: 'seed_cod1', full_name: 'Black Ops Fan', username: 'blackops_fan',
            avatar_url: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop' }
        });

        // Extra COD post 2
        localPosts.unshift({
          id: 'v6_cod_extra2',
          content: 'MW3 vs Black Ops 6 gunplay comparison — the recoil patterns are completely different. BO6 wins for me, the omnimovement makes it so much more dynamic. Which do YOU prefer? 🔫💥 #COD #FPS #Gaming',
          user_id: 'seed_cod2', userId: 'seed_cod2',
          video_url: '/videos/cod_real_1.mp4',
          media_type: 'video',
          created_at: new Date(Date.now() + 11000).toISOString(),
          likes: [], comments: [],
          author: { id: 'seed_cod2', full_name: 'Warzone King', username: 'warzone_king',
            avatar_url: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150&h=150&fit=crop' }
        });

        // Extra Battlefield post 1
        localPosts.unshift({
          id: 'v6_bf_extra1',
          content: 'Battlefield 2042 specialists finally feel RIGHT after the latest patch. The map destruction physics in this game are still unmatched by any other shooter on the market. 🪖💣 #Battlefield #Battlefield2042 #FPS',
          user_id: 'seed_bf1', userId: 'seed_bf1',
          video_url: '/videos/bf_real_1.mp4',
          media_type: 'video',
          created_at: new Date(Date.now() + 10000).toISOString(),
          likes: [], comments: [],
          author: { id: 'seed_bf1', full_name: 'BF Veteran', username: 'bf_veteran',
            avatar_url: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop' }
        });

        // Extra Battlefield post 2
        localPosts.unshift({
          id: 'v6_bf_extra2',
          content: 'The Battlefield series has always been about SCALE. 128 players, jets, tanks, helicopters, full levolution — nothing comes close. Battlefield 3 was the peak. 🎖️🔥 #Battlefield #BF3 #FPS #WarGame',
          user_id: 'seed_bf2', userId: 'seed_bf2',
          video_url: '/videos/bf_real_1.mp4',
          media_type: 'video',
          created_at: new Date(Date.now() + 9000).toISOString(),
          likes: [], comments: [],
          author: { id: 'seed_bf2', full_name: 'Squad Leader', username: 'squad_leader',
            avatar_url: 'https://images.unsplash.com/photo-1552058544-f2b08422138a?w=150&h=150&fit=crop' }
        });

        localStorage.setItem('local_posts', JSON.stringify(localPosts));
        localStorage.setItem('seed_v6_fps_extra_done', 'true');
      }

      if (!localStorage.getItem('seed_epic_unreal_done')) {
        const localPosts = JSON.parse(localStorage.getItem('local_posts') || '[]');

        // Epic Games / Fortnite
        localPosts.unshift({
          id: 'v6_epic_fortnite',
          content: 'Epic Games just dropped the most insane Fortnite Chapter update. Zero Build + the new movement system feels like a completely different game. The Unreal Engine 5 Nanite tech makes every blade of grass render in real time. 🎮🌿 #Fortnite #EpicGames #UnrealEngine5',
          user_id: 'seed_epic1', userId: 'seed_epic1',
          video_url: '/videos/epic_game1.mp4',
          media_type: 'video',
          created_at: new Date(Date.now() + 16000).toISOString(),
          likes: [], comments: [],
          author: { id: 'seed_epic1', full_name: 'Epic Hub', username: 'epic_hub',
            avatar_url: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=150&h=150&fit=crop' }
        });

        // Unreal Engine 5 tech demo
        localPosts.unshift({
          id: 'v6_unreal_tech',
          content: 'Unreal Engine 5 Lumen + Nanite in action. Real-time global illumination with no baking, infinite polygon geometry, and hardware ray tracing — this is what next-gen really means. The Matrix Awakens demo broke everyone\'s brain for a reason. 🔥⚡ #UnrealEngine5 #UE5 #GameDev #RealTimeRendering',
          user_id: 'seed_ue5', userId: 'seed_ue5',
          video_url: '/videos/unreal_demo1.mp4',
          media_type: 'video',
          created_at: new Date(Date.now() + 15000).toISOString(),
          likes: [], comments: [],
          author: { id: 'seed_ue5', full_name: 'UE5 Dev', username: 'ue5_dev',
            avatar_url: 'https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=150&h=150&fit=crop' }
        });

        // Unreal Engine Metahuman
        localPosts.unshift({
          id: 'v6_unreal_meta',
          content: 'MetaHuman Creator is absolutely insane. Created a photorealistic digital human in under 20 minutes — full facial rigging, skin subsurface scattering, and strand-based hair. Game characters will never look the same again. 🧑‍💻✨ #MetaHuman #EpicGames #UE5 #GameDev #CGI',
          user_id: 'seed_meta', userId: 'seed_meta',
          video_url: '/videos/unreal_demo2.mp4',
          media_type: 'video',
          created_at: new Date(Date.now() + 14000).toISOString(),
          likes: [], comments: [],
          author: { id: 'seed_meta', full_name: 'MetaHuman Artist', username: 'metahuman_art',
            avatar_url: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop' }
        });

        // Epic Games — general showcase
        localPosts.unshift({
          id: 'v6_epic_showcase',
          content: 'The amount of games shipping on Unreal Engine 5 this year is mind-blowing. Black Myth: Wukong, Fortnite OG, Ark 2, Indiana Jones — UE5 is literally the backbone of the entire gaming industry right now. 🕹️🔥 #UnrealEngine #EpicGames #GameDev #Gaming',
          user_id: 'seed_epic2', userId: 'seed_epic2',
          video_url: '/videos/epic_game2.mp4',
          media_type: 'video',
          created_at: new Date(Date.now() + 13000).toISOString(),
          likes: [], comments: [],
          author: { id: 'seed_epic2', full_name: 'Game Dev Weekly', username: 'gamedev_weekly',
            avatar_url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop' }
        });

        localStorage.setItem('local_posts', JSON.stringify(localPosts));
        localStorage.setItem('seed_epic_unreal_done', 'true');
      }

      if (hasLiveConvex) {
        const data = await convexClient.query("posts:getPosts");
        const localPosts = JSON.parse(localStorage.getItem('local_posts') || '[]');
        return this._mapLatestProfiles([...localPosts, ...(data || [])]);
      } else {
        throw new Error("No live Convex URL");
      }
    } catch (err) {
      console.warn("Failed to fetch posts from Convex, returning local fallback storage posts:", err);
      return this._mapLatestProfiles(JSON.parse(localStorage.getItem('local_posts') || '[]'));
    }
  },

  async getUserPosts(userId) {
    try {
      if (hasLiveConvex) {
        const data = await convexClient.query("posts:getUserPosts", { userId });
        const localPosts = JSON.parse(localStorage.getItem('local_posts') || '[]').filter(p => p.userId === userId || p.user_id === userId);
        return this._mapLatestProfiles([...localPosts, ...(data || [])]);
      } else {
        throw new Error("No live Convex URL");
      }
    } catch (err) {
      console.warn("Failed to fetch user posts from Convex, returning local fallback:", err);
      return this._mapLatestProfiles(JSON.parse(localStorage.getItem('local_posts') || '[]').filter(p => p.userId === userId || p.user_id === userId));
    }
  },

  async createPost(content, userId, mediaUrl = null, mediaType = 'image') {
    const newPost = {
      id: 'local_' + Date.now(),
      content,
      user_id: userId,
      userId,
      image_url: mediaType === 'image' ? mediaUrl : null,
      video_url: mediaType === 'video' ? mediaUrl : null,
      model_url: mediaType === 'model' ? mediaUrl : null,
      media_type: mediaType,
      created_at: new Date().toISOString(),
      likes: [],
      comments: [],
      author: {
        id: userId,
        full_name: 'You',
        username: 'you',
        avatar_url: 'https://images.unsplash.com/photo-1611695434398-4f4b330623e6'
      }
    };

    try {
      if (hasLiveConvex) {
        const result = await convexClient.mutation("posts:createPost", {
          content,
          userId,
          imageUrl: mediaType === 'image' ? (mediaUrl || undefined) : undefined,
          videoUrl: mediaType === 'video' ? (mediaUrl || undefined) : undefined,
          modelUrl: mediaType === 'model' ? (mediaUrl || undefined) : undefined,
          mediaType
        });
        window.dispatchEvent(new CustomEvent('new-post-created'));
        return result;
      } else {
        throw new Error("No live Convex URL");
      }
    } catch (err) {
      console.warn("Failed to save post to Convex, saving locally to local_posts fallback:", err);
      try {
        const localPosts = JSON.parse(localStorage.getItem('local_posts') || '[]');
        localPosts.unshift(newPost);
        localStorage.setItem('local_posts', JSON.stringify(localPosts));
      } catch (lsErr) {
        console.warn("LocalStorage quota exceeded or unavailable, keeping post in memory:", lsErr);
      }
      
      window.dispatchEvent(new CustomEvent('new-post-created'));
      return newPost;
    }
  },

  async deletePost(postId) {
    try {
      if (hasLiveConvex && !postId.startsWith('local_')) {
        await convexClient.mutation("posts:deletePost", { postId });
        return true;
      } else {
        throw new Error("Local post or no Convex URL");
      }
    } catch (err) {
      console.warn("Failed to delete post from Convex, removing from local fallback:", err);
      let localPosts = JSON.parse(localStorage.getItem('local_posts') || '[]');
      localPosts = localPosts.filter(p => p.id !== postId);
      localStorage.setItem('local_posts', JSON.stringify(localPosts));
      return true;
    }
  },

  async uploadMedia(file, type = 'image') {
    if (hasLiveConvex) {
      try {
        const postUrl = await convexClient.mutation("posts:generateUploadUrl");
        const result = await fetch(postUrl, {
          method: "POST",
          headers: { "Content-Type": file.type },
          body: file,
        });

        if (!result.ok) throw new Error("Upload failed");
        const { storageId } = await result.json();
        return storageId;
      } catch (err) {
        console.warn('Convex storage upload failed, falling back to local processing', err);
      }
    }
    
    // Fallback if no Live Convex or upload failed
    try {
      if (type === 'image') {
        const tempUrl = URL.createObjectURL(file);
        const compressedBlob = await new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => {
             try {
               const canvas = document.createElement('canvas');
               const ctx = canvas.getContext('2d');
               if (!ctx) throw new Error("Could not get canvas context");
               const MAX_WIDTH = 800;
               const MAX_HEIGHT = 800;
               let width = img.width || 800;
               let height = img.height || 800;
               if (width > height) {
                 if (width > MAX_WIDTH) { height *= MAX_WIDTH / width; width = MAX_WIDTH; }
               } else {
                 if (height > MAX_HEIGHT) { width *= MAX_HEIGHT / height; height = MAX_HEIGHT; }
               }
               canvas.width = Math.floor(width);
               canvas.height = Math.floor(height);
               ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
               resolve(canvas.toDataURL('image/jpeg', 0.6));
             } catch(e) {
               reject(e);
             }
          };
          img.onerror = () => reject(new Error("Image compression failed"));
          img.src = tempUrl;
        });
        return compressedBlob; // Returns base64 directly, highly reliable for localStorage
      } else if (type === 'model') {
        // For 3D models, directly save to IndexedDB or return URL
        return await idbStorage.saveMedia(file, 'model');
      } else {
        // For video, directly save file blob to IndexedDB
        return await idbStorage.saveMedia(file, 'video');
      }
    } catch (err) {
      console.warn("Local storage fallback failed:", err);
      return URL.createObjectURL(file); // absolute last resort
    }
  },

  async toggleLike(postId, userId) {
    try {
      if (hasLiveConvex && !postId.startsWith('local_')) {
        return await convexClient.mutation("likes:toggleLike", { postId, userId });
      } else {
        throw new Error("Local post or no Convex URL");
      }
    } catch (err) {
      console.warn("Falling back to local toggleLike simulation:", err);
      const likedPosts = JSON.parse(localStorage.getItem('liked_posts') || '{}');
      const isLiked = !likedPosts[postId];
      likedPosts[postId] = isLiked;
      localStorage.setItem('liked_posts', JSON.stringify(likedPosts));
      return { liked: isLiked };
    }
  },

  async addComment(postId, userId, content) {
    try {
      if (hasLiveConvex && !postId.startsWith('local_')) {
        return await convexClient.mutation("comments:addComment", { postId, userId, content });
      } else {
        throw new Error("Local post or no Convex URL");
      }
    } catch (err) {
      console.warn("Falling back to local addComment simulation:", err);
      const newComment = {
        id: 'local_comment_' + Date.now(),
        post_id: postId,
        user_id: userId,
        content,
        created_at: new Date().toISOString(),
        author: 'You',
        avatar: 'https://images.unsplash.com/photo-1611695434398-4f4b330623e6'
      };
      
      const localComments = JSON.parse(localStorage.getItem(`comments_${postId}`) || '[]');
      localComments.push(newComment);
      localStorage.setItem(`comments_${postId}`, JSON.stringify(localComments));
      return newComment;
    }
  },

  subscribeToPosts(callback) {
    const listener = () => {
      callback({ eventType: 'INSERT' });
    };
    window.addEventListener('new-post-created', listener);
    return {
      unsubscribe: () => {
        window.removeEventListener('new-post-created', listener);
      }
    };
  }
};
